export default __webpack_public_path__ + "static/media/sub-app-timecard-reminder-logo.fb2d9594437eb44087aad481299bb3a8.png";